import api from "../../../service/api";
import ActionTypes from "../../actionTypes";
import API_BOOK from "../../../service/endpoints";

const { GET_ALL_DATA_SUCCESS, GET_ALL_DATA_FAIL } = ActionTypes.REPORTS.KM_BAD_PINGS;
const { GET_KM_BAD_PINGS } = API_BOOK.REPORTS.KM_REPORT;

/* Action dispatchers */

const getAllKmBadPingsSuccessAD = (payload) => ({
  type: GET_ALL_DATA_SUCCESS,
  payload,
});

const getAllKmBadPingsFailAD = () => ({
  type: GET_ALL_DATA_FAIL,
});

/* Actions */

/**
 *  @desc         Get KM Bad Pings data
 *  @api          /reports/km-bad-pings
 *  @method       POST
 **/
export const GetKmBadPings = ({ registrationNumbers, fromDate, toDate, pageSize, pageIndex }) => async (dispatch) => {
  try {
    const resp = await api({
      method: GET_KM_BAD_PINGS.method,
      url: GET_KM_BAD_PINGS.url,
      data: {
        registrationNumbers: registrationNumbers?.map((val) => val.label),
        fromDate,
        toDate,
        pageSize,
        pageIndex,
      }
    });

    if (resp.status === 200 && resp?.data?.data) {
      const response = resp?.data?.data;
      dispatch(getAllKmBadPingsSuccessAD(response));
    } else {
      dispatch(getAllKmBadPingsFailAD());
    }
  } catch (error) {
    dispatch(getAllKmBadPingsFailAD());
    console.log("error:", error);
  }
};
